/**
 * @generated SignedSource<<0090840bcf2480efb58af1f95e7b6ead>>
 * @relayHash fe76c7604dae204197c3aa5ef7b824ca
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-misc/387.0.0-2022-10-18T11:57:33.985Z/shopLocalConfigQuery

import { ConcreteRequest, Query } from 'relay-runtime';
export type shopLocalConfigQuery$variables = {};
export type shopLocalConfigQuery$data = {
  readonly viewer: {
    readonly shopLocalNotificationFeatureFlag: boolean | null;
  };
};
export type shopLocalConfigQuery = {
  response: shopLocalConfigQuery$data;
  variables: shopLocalConfigQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": "shopLocalNotificationFeatureFlag",
  "args": [
    {
      "kind": "Literal",
      "name": "feature",
      "value": "shopLocalNotification"
    }
  ],
  "kind": "ScalarField",
  "name": "featureFlag",
  "storageKey": "featureFlag(feature:\"shopLocalNotification\")"
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "shopLocalConfigQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "shopLocalConfigQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-misc/387.0.0-2022-10-18T11:57:33.985Z/shopLocalConfigQuery",
    "metadata": {},
    "name": "shopLocalConfigQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "02f69596217db106a6887cd1e300c106";

export default node;
